
<footer>
    <p class="text-center">
        © Copyright 2024. All Rights Reserved. Powered by {{domain}}.
        <a href="mailto:info@diamondexch.com" class="mail-link white">info@{{domain}}</a>
    </p>
</footer>

  <ng-template #loginCnfm>
    <div class="login-popup-content ">
        <div class="header-popup">
            <span class="close" (click)="modalRef.hide();"><i class="fa fa-close" style="font-size:24px"></i></span>
        </div>
        <div class="login-panel-container confirm-container " [innerHTML]="contentReceived">
        </div>
        <div class="confirm-button">
            <button class="btn-verification btn-confirm" (click)="modalRef.hide();">
                <span>OK</span>
            </button>
        </div>
    </div>
</ng-template>

<div class="col-md-12" style="display: none;">
    <div class="inner-footer">
        <div class="support-wrap">
            <dl class="support-mail">
                <a class="rules-btn-home" routerLink="/about-us">About Us</a>
                <a class="rules-btn-home" routerLink="/privacy-policy">Privacy Policy</a>
                <a class="rules-btn-home" routerLink="/contact-us">Terms Conditions</a>
                <a class="rules-btn-home" routerLink="/term-conditions">Contact Us</a>
            </dl>
            
        </div>
    </div>
</div>